import { Component, Input } from '@angular/core';
import { DeviceSyncStatus, SyncType } from '@era/locations-sdk';
import { DeviceSyncStatusIndicatorComponent } from './device-sync-status-indicator.component';
import { DeviceSyncStatusRetryContainerComponent } from './device-sync-status-retry.container';
import { DeviceMdmSyncRetryContainerComponent } from '../device-mdm-sync-retry/device-mdm-sync-retry.container';

@Component({
  selector: 'era-device-sync-status-ui',
  templateUrl: './device-sync-status.component.html',
  styleUrls: ['./device-sync-status.component.scss'],
  imports: [
    DeviceSyncStatusIndicatorComponent,
    DeviceSyncStatusRetryContainerComponent,
    DeviceMdmSyncRetryContainerComponent,
  ],
})
export class DeviceSyncStatusComponent {
  @Input() public deviceStatus: DeviceSyncStatus;
  SyncType = SyncType;
}
